import script from "./FormularioVenda.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioVenda.vue?vue&type=script&setup=true&lang=js"

import "./FormularioVenda.vue?vue&type=style&index=0&id=1d09dba4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d09dba4"]])

export default __exports__